export const DEFAULT_CURRENCY_BAR_LABEL =
  "Earn certificate and unlock for full access";

export const DEFAULT_CURRENCY_BAR_MOBILE_LABEL = "Choose your local currency";

export const DEFAULT_CYT_CURRENCY_SUBHEADER_LABEL =
  "Change price to your local currency";

export const CURRENCY_BAR_LABEL_CLASS_NAME =
  "font-inter text-sm font-medium leading-5 text-[var(--Text-on-Light-Black,#000)]";
